// Cookies
export const COOKIE_USER = 'UserName'
export const COOKIE_TOKEN = 'Token'
export const COOKIE_PERIOD = 1 * 24 * 60 * 60 * 1000 // Equals 1 day

// Timeout
export const TIMEOUT = 30000
export const TIMEOUT_MESSAGE = 'Request Timeout'
export const TIMEOUT_UPLOAD = 60000
export const MAX_LOOP_CONN = 10

// Network
export const HOME_PATH = '/home'
export const HOME_PATHNAME = 'Home'
export const PROFILE_PATH = '/profile'
export const PROFILE_PATHNAME = 'Profile'
export const HELP_PATH = '/help'
export const HELP_PATHNAME = 'Help'
export const ABOUT_PATH = '/about'
export const ABOUT_PATHNAME = 'About'
export const CONTACT_PATH = '/contact'
export const CONTACT_PATHNAME = 'Contact'
export const LOGIN_PATH = '/login'
export const LOGIN_PATHNAME = 'Login'
export const LOGOUT_PATH = '/logout'
export const LOGOUT_PATHNAME = 'Logout'

// Users
export const USER_PATH = '/users'
export const USER_PATHNAME = 'Users'
export const USER_LIST_PATH = 'userlist'
export const USER_LIST_PATHNAME = 'userlist'
export const USER_ADD_PATH = 'adduser'
export const USER_ADD_PATHNAME = 'adduser'

// Consumers
export const CONSUMER_PATH = '/consumers'
export const CONSUMER_PATHNAME = 'Consumers'
export const CONSUMER_LIST_PATH = 'consumerlist'
export const CONSUMER_LIST_PATHNAME = 'consumerlist'
export const CONSUMER_ADD_PATH = 'consumeradd'
export const CONSUMER_ADD_PATHNAME = 'consumeradd'

// Deliverable
export const DELIVERABLE_PATH = '/deliverables'
export const DELIVERABLE_PATHNAME = 'Deliverables'
export const DELIVERABLE_LIST_PATH = 'deliverablelist'
export const DELIVERABLE_LIST_PATHNAME = 'deliverablelist'
export const DELIVERABLE_ADD_PATH = 'deliverableadd'
export const DELIVERABLE_ADD_PATHNAME = 'deliverableadd'
export const DELIVERABLE_EDIT_PATH = 'deliverableedit'
export const DELIVERABLE_EDIT_PATHNAME = 'deliverableedit'
export const DELIVERABLE_ASSIGN_PATH = 'deliverableassign'
export const DELIVERABLE_ASSIGN_PATHNAME = 'deliverableassign'

// Versions
export const VERSION_PATH = '/versions'
export const VERSION_PATHNAME = 'Versions'
export const VERSION_LIST_PATH = '/versionlist'
export const VERSION_LIST_PATHNAME = 'versionlist'
export const VERSION_ADD_PATH = '/versionadd'
export const VERSION_ADD_PATHNAME = 'versionadd'

// IDS Policy Routes
export const IDSPOLICY_PATH = '/idspolicies'
export const IDSPOLICY_PATHNAME = 'IDS Policies'
export const IDSPOLICY_OS_PATH = 'idsplcos'
export const IDSPOLICY_OS_PATHNAME = 'idsplcos'
export const IDSPOLICY_CLIENT_PATH = 'idsplcclient'
export const IDSPOLICY_CLIENT_PATHNAME = 'idsplcclient'
export const IDSPOLICY_DETAIL_PATH = 'idsplcdetail'
export const IDSPOLICY_DETAIL_PATHNAME = 'idsplcdetail'
export const ADD_IDSPOLICY_PATH = 'addidspolicy'
export const ADD_IDSPOLICY_PATHNAME = 'Add IDS Policy'
export const EDIT_IDSPOLICY_PATH = 'editidspolicy'
export const EDIT_IDSPOLICY_PATHNAME = 'Edit IDS Policy'
export const DUPLICATE_IDSPOLICY_PATH = 'dupidspolicy'
export const DUPLICATE_IDSPOLICY_PATHNAME = 'Duplicate IDS Policy'

// IDS Policy Template Routes
export const IDSPOLICY_TEMP_PATH = '/idspolicytemplates'
export const IDSPOLICY_TEMP_PATHNAME = 'IDS Policy Templates'
export const IDSPOLICY_TEMP_OS_PATH = 'idsplctempos'
export const IDSPOLICY_TEMP_OS_PATHNAME = 'idsplctempos'
export const IDSPOLICY_TEMP_DETAIL_PATH = 'idsplctempdetail'
export const IDSPOLICY_TEMP_DETAIL_PATHNAME = 'idsplctempdetail'
export const IDSPOLICY_TEMP_EDIT_PATH = 'idsplctempedit'
export const IDSPOLICY_TEMP_EDIT_PATHNAME = 'idsplctempedit'
export const IDSPOLICY_TEMP_ADD_PATH = 'idsplctempadd'
export const IDSPOLICY_TEMP_ADD_PATHNAME = 'idsplctempadd'

// Remote Policy Routes
export const REMOTE_POLICY_PATH = '/remotepolicies'
export const REMOTE_POLICY_PATHNAME = 'Remote Policies'
export const REMOTE_POLICY_LIST_PATH = 'remotepolicylist'
export const REMOTE_POLICY_LIST_PATHNAME = 'remotepolicylist'
export const REMOTE_POLICY_EDIT_PATH = 'remotepolicyedit'
export const REMOTE_POLICY_EDIT_PATHNAME = 'remotepolicyedit'
export const REMOTE_POLICY_ADD_PATH = 'remotepolicyadd'
export const REMOTE_POLICY_ADD_PATHNAME = 'remotepolicyadd'

// Remote Report Policy Routes
export const REMOTE_REPORT_POLICY_PATH = '/remotereportpolicies'
export const REMOTE_REPORT_POLICY_PATHNAME = 'Remote Report Policies'
export const REMOTE_REPORT_POLICY_LIST_PATH = 'remotereportpolicylist'
export const REMOTE_REPORT_POLICY_LIST_PATHNAME = 'remotereportpolicylist'
export const REMOTE_REPORT_POLICY_EDIT_PATH = 'remotereportpolicyedit'
export const REMOTE_REPORT_POLICY_EDIT_PATHNAME = 'remotereportpolicyedit'
export const REMOTE_REPORT_POLICY_ADD_PATH = 'remotereportpolicyadd'
export const REMOTE_REPORT_POLICY_ADD_PATHNAME = 'remotereportpolicyadd'

// Deliverable Type Routes
export const DELIVERABLE_TYPE_PATH = '/deliverablestypes'
export const DELIVERABLE_TYPE_PATHNAME = 'Deliverables Types'
export const DELIVERABLE_TYPE_LIST_PATH = 'deliverablestypelist'
export const DELIVERABLE_TYPE_LIST_PATHNAME = 'deliverablestypelist'
export const DELIVERABLE_TYPE_ADD_PATH = 'deliverablestypeadd'
export const DELIVERABLE_TYPE_ADD_PATHNAME = 'deliverablestypeadd'

// Target OS Routes
export const TARGET_OS_PATH = '/targetos'
export const TARGET_OS_PATHNAME = 'Target OS'
export const TARGET_OS_LIST_PATH = 'targetoslist'
export const TARGET_OS_LIST_PATHNAME = 'targetoslist'
export const TARGET_OS_ADD_PATH = 'targetosadd'
export const TARGET_OS_ADD_PATHNAME = 'targetosadd'

// Artefact Routes
export const ARTEFACT_PATH = '/artefacts'
export const ARTEFACT_PATHNAME = 'Artefacts'
export const ARTEFACT_VERSION_LIST_PATH = 'artefactverlist'
export const ARTEFACT_VERSION_LIST_PATHNAME = 'artefactverlist'
export const ARTEFACT_LIST_PATH = 'artefactlist'
export const ARTEFACT_LIST_PATHNAME = 'artefactlist'
export const ARTEFACT_ADD_PATH = 'artefactadd'
export const ARTEFACT_ADD_PATHNAME = 'artefactadd'
export const ARTEFACT_EDIT_PATH = 'artefactlistedit'
export const ARTEFACT_EDIT_PATHNAME = 'artefactlistedit'

// GitLab Project Routes
export const GITLAB_PATH = '/gitlabprojects'
export const GITLAB_PATHNAME = 'Gitlab Projects'
export const GITLAB_LIST_PATH = 'gitlabprojectlist'
export const GITLAB_LIST_PATHNAME = 'gitlabprojectlist'
export const GITLAB_ADD_PATH = 'gitlabprojectadd'
export const GITLAB_ADD_PATHNAME = 'gitlabprojectadd'
export const GITLAB_EDIT_PATH = 'gitlabprojectedit'
export const GITLAB_EDIT_PATHNAME = 'gitlabprojectedit'

// Artifact Repository Routes
export const ARTIFACT_REPO_PATH = '/artifactrepositories'
export const ARTIFACT_REPO_PATHNAME = 'Artifact Repositories'
export const ARTIFACT_REPO_LIST_PATH = 'artifactrepositorylist'
export const ARTIFACT_REPO_LIST_PATHNAME = 'artifactrepositorylist'
export const ARTIFACT_REPO_ADD_PATH = 'artifactrepositoryadd'
export const ARTIFACT_REPO_ADD_PATHNAME = 'artifactrepositoryadd'
export const ARTIFACT_REPO_EDIT_PATH = 'artifactrepositoryedit'
export const ARTIFACT_REPO_EDIT_PATHNAME = 'artifactrepositoryedit'

// Auto Pentest Routes
export const AUTO_PENTEST_PATH = '/autopentests'
export const AUTO_PENTEST_PATHNAME = 'Auto Pentest'
export const AUTO_PENTEST_LIST_PATH = 'autopentestlist'
export const AUTO_PENTEST_LIST_PATHNAME = 'autopentestlist'
export const AUTO_PENTEST_ADD_PATH = 'autopentestadd'
export const AUTO_PENTEST_ADD_PATHNAME = 'autopentestadd'

// Entity Routes
export const ENTITY_PATH = '/entities'
export const ENTITY_PATHNAME = 'Entities'
export const ENTITY_LIST_PATH = 'entitylist'
export const ENTITY_LIST_PATHNAME = 'entitylist'
export const ENTITY_ADD_PATH = 'entityadd'
export const ENTITY_ADD_PATHNAME = 'entityadd'

// Product Routes
export const PRODUCT_PATH = '/products'
export const PRODUCT_PATHNAME = 'Products'
export const PRODUCT_LIST_PATH = 'productlist'
export const PRODUCT_LIST_PATHNAME = 'productlist'
export const PRODUCT_ADD_PATH = 'productadd'
export const PRODUCT_ADD_PATHNAME = 'productadd'

// Whitebox Keys Routes
export const WBK_PATH = '/wbks'
export const WBK_PATHNAME = 'Whitebox Keys'
export const WBK_LIST_PATH = 'wbklist'
export const WBK_LIST_PATHNAME = 'wbklist'

// KeySets Routes
export const KS_PATH = '/ks'
export const KS_PATHNAME = 'KeySets'
export const KS_LIST_PATH = 'kslist'
export const KS_LIST_PATHNAME = 'kslist'

// BW Certificates Routes
export const BW_CRT_PATH = '/bwcrts'
export const BW_CRT_PATHNAME = 'BW Certificates'
export const BW_CRT_LIST_PATH = 'bwcrtlist'
export const BW_CRT_LIST_PATHNAME = 'bwcrtlist'

// Token Routes
export const TOKEN_PATH = '/tokens'
export const TOKEN_PATHNAME = 'Tokens'
export const TOKEN_LIST_PATH = 'tokenlist'
export const TOKEN_LIST_PATHNAME = 'tokenlist'
export const TOKEN_ADD_PATH = 'tokenadd'
export const TOKEN_ADD_PATHNAME = 'tokenadd'
export const TOKEN_EDIT_PATH = 'tokenedit'
export const TOKEN_EDIT_PATHNAME = 'tokenedit'

// IDS Report Policy Routes
export const IDSREPORTPOLICY_PATH = '/idsreportpolicies'
export const IDSREPORTPOLICY_PATHNAME = 'IDS Report Policies'
export const IDSREPORTPOLICY_OS_PATH = 'idsreportplcos'
export const IDSREPORTPOLICY_OS_PATHNAME = 'idsreportplcos'
export const IDSREPORTPOLICY_CLIENT_PATH = 'idsreportplcclient'
export const IDSREPORTPOLICY_CLIENT_PATHNAME = 'idsreportplcclient'
export const IDSREPORTPOLICY_DETAIL_PATH = 'idsreportplcdetail'
export const IDSREPORTPOLICY_DETAIL_PATHNAME = 'idsreportplcdetail'
export const ADD_IDSREPORTPOLICY_PATH = 'addidsreportpolicy'
export const ADD_IDSREPORTPOLICY_PATHNAME = 'Add IDS Report Policy'
export const EDIT_IDSREPORTPOLICY_PATH = 'editidsreportpolicy'
export const EDIT_IDSREPORTPOLICY_PATHNAME = 'Edit IDS Report Policy'
export const DUPLICATE_IDSREPORTPOLICY_PATH = 'dupidsreportpolicy'
export const DUPLICATE_IDSREPORTPOLICY_PATHNAME = 'Duplicate IDS Report Policy'

// IDS Report Policy Template Routes
export const IDSREPORTPOLICY_TEMP_PATH = '/idsreportpolicytemplates'
export const IDSREPORTPOLICY_TEMP_PATHNAME = 'IDS Report Policy Templates'
export const IDSREPORTPOLICY_TEMP_OS_PATH = 'idsreportplctempos'
export const IDSREPORTPOLICY_TEMP_OS_PATHNAME = 'idsreportplctempos'
export const IDSREPORTPOLICY_TEMP_DETAIL_PATH = 'idsreportplctempdetail'
export const IDSREPORTPOLICY_TEMP_DETAIL_PATHNAME = 'idsreportplctempdetail'
export const IDSREPORTPOLICY_TEMP_EDIT_PATH = 'idsreportplctempedit'
export const IDSREPORTPOLICY_TEMP_EDIT_PATHNAME = 'Edit IDS Report Policy Template'
export const IDSREPORTPOLICY_TEMP_ADD_PATH = 'idsreportplctempadd'
export const IDSREPORTPOLICY_TEMP_ADD_PATHNAME = 'Duplicate IDS Report Policy Template'

// TOP CONFIGS
// Top Minimum Distance to show backTop Button
export const TOP_MINDISTANCE = 150

// TOP Buttons
// Top Add Button
export const TOP_ADD_BUTTON_TEXT = 'Add'
export const TOP_ADD_BUTTON_ICON = 'fa fa-plus'
export const TOP_ADD_BUTTON_STYLE = 'button is-success is-outlined'

// TOP Back Button
export const TOP_BACK_BUTTON_TEXT = 'Back'
export const TOP_BACK_BUTTON_ICON = 'fa fa-arrow-left'
export const TOP_BACK_BUTTON_STYLE = 'button is-success is-outlined'

// TOP Back Blue Button
export const TOP_BACK_ALL_BUTTON_STYLE = 'button is-info is-outlined'

// Return To MainPage Button
export const TOP_RETURN_BUTTON_TEXT = 'Return to Main Page'
export const TOP_RETURN_BUTTON_ICON = 'fas fa-fast-backward'
export const TOP_RETURN_BUTTON_STYLE = 'button is-info is-outlined'

// TOP Edit Button
export const TOP_EDIT_BUTTON_TEXT = 'Edit'
export const TOP_EDIT_BUTTON_ICON = 'fa fa-pen'
export const TOP_EDIT_BUTTON_STYLE = 'button is-info'

// Top Delete Button
export const TOP_DUPLICATE_BUTTON_TEXT = 'Duplicate'
export const TOP_DUPLICATE_BUTTON_ICON = 'far fa-clone'
export const TOP_DUPLICATE_BUTTON_STYLE = 'button is-success'

// Top Delete Button
export const TOP_DELETE_BUTTON_TEXT = 'Delete'
export const TOP_DELETE_BUTTON_ICON = 'fa fa-times'
export const TOP_DELETE_BUTTON_STYLE = 'button is-danger is-outlined'

// TOP BAR CONFIGS
// Top Bar
export const TITLE = 'SDS Control Center'

// Top Bar Menu Item
const DOCUMENTATION_LINK = 'https://confluence.worldline-solutions.com/display/ITAMSP/Secure+Delivery+System+Documentation'
const DOCUMENTATION_ICON = 'fas fa-book'
const DOCUMENTATION_TEXT = 'Documentation'
const NEXUS_LINK = 'https://ssl-prd-uz0-sds.worldline-solutions.com/nexus/'
const NEXUS_TEXT = 'SDS-Nexus'
const API_ICON = 'fas fa-robot'
const API_LINK = 'https://go-sds-data-access-msc-sds-1.apps.dev.caas4noprd.svc.meshcore.net/data_access/swagger/index.html'
const API_TEXT = 'Data Access API'

// Top Bar Menu List
export const TOP_MENU_LIST = [
  { link: DOCUMENTATION_LINK, icon: DOCUMENTATION_ICON, text: DOCUMENTATION_TEXT },
  { link: NEXUS_LINK, text: NEXUS_TEXT },
  { link: API_LINK, icon: API_ICON, text: API_TEXT }
]

// Top Bar Drop-Down Items
const PROFILE_ICON = 'fas fa-cog'
const HELP_ICON = 'fa fa-question-circle'
const ABOUT_ICON = 'fa fa-info'
const CONTACT_ICON = 'fa fa-pencil-alt'
const LOGOUT_ICON = 'fa fa-sign-out-alt'

// Top Bar Drop Down List
export const TOP_DROPDOWN_LIST = [
  { link: PROFILE_PATH, icon: PROFILE_ICON, text: PROFILE_PATHNAME },
  { divider: true },
  { link: HELP_PATH, icon: HELP_ICON, text: HELP_PATHNAME },
  { link: ABOUT_PATH, icon: ABOUT_ICON, text: ABOUT_PATHNAME },
  { link: CONTACT_PATH, icon: CONTACT_ICON, text: CONTACT_PATHNAME },
  { divider: true },
  { link: LOGOUT_PATH, icon: LOGOUT_ICON, text: LOGOUT_PATHNAME }
]

// Text Buttons
// Delete Button
export const OP_DELETE_ICON = 'fas fa-times'
export const OP_DELETE_STYLE = 'button is-danger is-small is-outlined'
export const OP_DELETE_STYLE_BIG = 'button is-danger is-outlined'
export const OP_DELETE_MSG = 'Delete'

// Discard Button
export const OP_DISCARD_ICON = 'fas fa-undo'
export const OP_DISCARD_STYLE = 'button is-dark is-small is-outlined'
export const OP_DISCARD_STYLE_BIG = 'button is-dark is-outlined'
export const OP_DISCARD_MSG = 'Discard'

// Edit Button
export const OP_EDIT_ICON = 'fa fa-pen'
export const OP_EDIT_STYLE = 'button is-link is-small is-outlined'

// Renew Button
export const OP_RENEW_ICON = 'fas fa-sync-alt'
export const OP_RENEW_STYLE = 'button is-info is-small is-outlined'

// Add Button
export const OP_ADD_ICON = 'fa fa-plus'
export const OP_ADD_STYLE = 'button is-info is-outlined'
export const OP_ADD_MSG = 'Add'

// Icon Buttons
// Add Button
export const OP_CHECK_ICON = 'fas fa-check'
export const OP_CHECK_STYLE = 'button is-success is-outlined is-small'
export const OP_CHECK_MSG = 'Done'

// Submit Button
export const SUBMIT_BUTTON_TEXT = 'Submit'
export const SUBMIT_BUTTON_ICON = 'fa fa-plus'
export const SUBMIT_BUTTON_STYLE = 'button is-info'

// Link Button
export const LINK_BUTTON_ICON = 'fa fa-link'
export const LINK_BUTTON_STYLE = 'button is-info is-outlined is-small'
export const LINK_BUTTON_STYLE_BIG = 'button is-info is-outlined'

// Branch Button
export const BRANCH_BUTTON_ICON = 'fa fa-code-branch'
export const BRANCH_BUTTON_STYLE = 'button is-info is-outlined is-small'
export const BRANCH_BUTTON_STYLE_BIG = 'button is-info is-outlined'

// Clone Button
export const CLONE_BUTTON_ICON = 'fas fa-clone'
export const CLONE_BUTTON_STYLE = 'button is-success is-outlined is-small'
export const CLONE_BUTTON_STYLE_BIG = 'button is-success is-outlined'

// Build Button
export const BUILD_BUTTON_ICON = 'fas fa-hammer'
export const BUILD_BUTTON_STYLE = 'button is-link is-outlined is-small'
export const BUILD_BUTTON_STYLE_BIG = 'button is-link is-outlined'

// OTHER ICONs
export const CALENDAR_ICON = 'fas fa-calendar-alt'

// LEFT PANEL CONFIGS
// Left Panel Constants
const USER_ICON = 'fas fa-user'
const CONSUMER_ICON = 'fas fa-user-friends'
const DELIVERABLE_ICON = 'fas fa-boxes'
const IDSPOLICY_ICON = 'fas fa-tasks'
const IDSPOLICY_TEMP_ICON = 'fas fa-th-list'
const IDSPOLICY_TEMP_AUTH = 2
const DELIVERABLE_TYPE_ICON = 'fas fa-box'
const DELIVERABLE_AUTH = 1
const TARGET_OS_ICON = 'fab fa-android'
const TARGET_OS_AUTH = 1
const REMOTE_POLICY_ICON = 'fas fa-stream'
const REMOTE_POLICY_AUTH = 2
const REMOTE_REPORT_POLICY_ICON = 'fas fa-file-upload'
const REMOTE_REPORT_POLICY_AUTH = 2
const ARTEFACT_ICON = 'fas fa-gift'
const GITLAB_ICON = 'fab fa-gitlab'
const ARTIFACT_REPO_ICON = 'fas fa-warehouse'
const AUTO_PENTEST_ICON = 'fas fa-user-secret'
const ENTITY_ICON = 'fas fa-users'
const PRODUCT_ICON = 'fas fa-rocket'
const IDSREPORTPOLICY_ICON = 'fas fa-file-alt'
const IDSREPORTPOLICY_TEMP_ICON = 'fas fa-file'
const IDSREPORTPOLICY_TEMP_AUTH = 2

// Export the Panel List
export const PANEL_LIST = [
  { link: USER_PATH, icon: USER_ICON, text: USER_PATHNAME },
  { link: CONSUMER_PATH, icon: CONSUMER_ICON, text: CONSUMER_PATHNAME },
  { link: DELIVERABLE_PATH, icon: DELIVERABLE_ICON, text: DELIVERABLE_PATHNAME },
  { link: IDSPOLICY_PATH, icon: IDSPOLICY_ICON, text: IDSPOLICY_PATHNAME },
  { link: IDSPOLICY_TEMP_PATH, icon: IDSPOLICY_TEMP_ICON, text: IDSPOLICY_TEMP_PATHNAME, authLvl: IDSPOLICY_TEMP_AUTH },
  { link: IDSREPORTPOLICY_PATH, icon: IDSREPORTPOLICY_ICON, text: IDSREPORTPOLICY_PATHNAME },
  { link: IDSREPORTPOLICY_TEMP_PATH, icon: IDSREPORTPOLICY_TEMP_ICON, text: IDSREPORTPOLICY_TEMP_PATHNAME, authLvl: IDSREPORTPOLICY_TEMP_AUTH },
  { link: REMOTE_POLICY_PATH, icon: REMOTE_POLICY_ICON, text: REMOTE_POLICY_PATHNAME, authLvl: REMOTE_POLICY_AUTH },
  { link: REMOTE_REPORT_POLICY_PATH, icon: REMOTE_REPORT_POLICY_ICON, text: REMOTE_REPORT_POLICY_PATHNAME, authLvl: REMOTE_REPORT_POLICY_AUTH },
  { link: DELIVERABLE_TYPE_PATH, icon: DELIVERABLE_TYPE_ICON, text: DELIVERABLE_TYPE_PATHNAME, authLvl: DELIVERABLE_AUTH },
  { link: TARGET_OS_PATH, icon: TARGET_OS_ICON, text: TARGET_OS_PATHNAME, authLvl: TARGET_OS_AUTH },
  { link: ARTEFACT_PATH, icon: ARTEFACT_ICON, text: ARTEFACT_PATHNAME },
  { link: GITLAB_PATH, icon: GITLAB_ICON, text: GITLAB_PATHNAME },
  { link: ARTIFACT_REPO_PATH, icon: ARTIFACT_REPO_ICON, text: ARTIFACT_REPO_PATHNAME },
  { link: AUTO_PENTEST_PATH, icon: AUTO_PENTEST_ICON, text: AUTO_PENTEST_PATHNAME },
  { link: ENTITY_PATH, icon: ENTITY_ICON, text: ENTITY_PATHNAME },
  { link: PRODUCT_PATH, icon: PRODUCT_ICON, text: PRODUCT_PATHNAME }
]

// IDS POLICY CONFIGS
// IDS Policy OS Tabs
export const IDSPLC_ANDROID_TEXT = 'Android'
export const IDSPLC_ANDROID_ICON = 'fab fa-android'
export const IDSPLC_IOS_TEXT = 'IOS'
export const IDSPLC_IOS_ICON = 'fab fa-apple'
export const IDSPLC_OTHERS_TEXT = 'Others'
export const IDSPLC_OTHERS_ICON = 'fas fa-mobile-alt'
export const IDSPLC_LINUX_ICON = 'fab fa-linux'

// Export ids list
export const IDSPLC_OS_TAB = [
  { icon: IDSPLC_ANDROID_ICON, text: IDSPLC_ANDROID_TEXT },
  { icon: IDSPLC_IOS_ICON, text: IDSPLC_IOS_TEXT },
  { icon: IDSPLC_OTHERS_ICON, text: IDSPLC_OTHERS_TEXT }
]

// IDS Policy Status
export const STATUS_FATAL = 'STATUS_FATAL'
export const STATUS_WARNING = 'STATUS_WARNING'

// IDS Name Format
export const IDS_NAME_FORMAT_MATCH = /[\w-]{1,40}/

// IDS Version Format
export const IDS_VERSION_FORMAT_MATCH = /[0-9]+\.[0-9]+\.[0-9]+/

// Remote Policy Label Format
export const RMT_PLC_NAME_FORMAT_TEXT = '<label>-<android | ios>'
export const RMT_PLC_NAME_FORMAT_MATCH = /[A-Za-z-_0-9]{1,50}-(android|ios)$/

// Client Name Format
export const CLIENT_NAME_FORMAT = /[^A-Za-z0-9-_.]/

// Package Name Format
export const PACKAGE_NAME_FORMAT = /[^A-Za-z0-9-_.]/

// Artefact Icons
export const ENV_PROD = 'fas fa-industry'
export const ENV_DEV = 'fas fa-laptop-code'

// Whitebox Key
export const WBK_BUTTON_STYLE = 'button is-primary is-outlined'
export const WBK_BUTTON_ICON = 'fas fa-key'
export const WBK_BUTTON_TEXT = 'Manage Whitebox Keys'

// KeySets
export const KS_BUTTON_STYLE = 'button is-primary is-outlined'
export const KS_BUTTON_ICON = 'fas fa-key'
export const KS_BUTTON_TEXT = 'Manage KeySets'

// Notification Style
export const SUCCESS_STYLE = 'is-success'
export const ERROR_STYLE = 'is-danger'

// BW Certificate
export const BW_CRT_STYLE = 'button is-primary is-outlined'
export const BW_CRT_ICON = 'fas fa-key'
export const BW_CRT_BUTTON_TEXT = 'Manage BW Certificates'
